export default "__VITE_ASSET__Cjqu_P4H__"